import { sessaoFetchLoading } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function get (id) {
  return sessaoFetchLoading(`base`, `/regra/tabela/comissionamentobancos/${id}`)
}
export async function getRegras (dados) {
  return sessaoFetchLoading(`base`, `/regra/tabela/comissionamentobancos?` + serialize(dados), 'GET')
}
export async function add (dados) {
  return sessaoFetchLoading(`base`, `/regra/tabela/comissionamentobancos/`, 'POST', dados)
}
export async function edit (dados) {
  return sessaoFetchLoading(`base`, `/regra/tabela/comissionamentobancos/${dados.id}`, 'PUT', dados)
}
export async function delRegra (dados) {
  return sessaoFetchLoading(`base`, `/regra/tabela/comissionamentobancos/${dados}`, 'DELETE')
}



// WEBPACK FOOTER //
// ./src/api/regrasbancos.js